import {ElementType, forwardRef, Fragment, MouseEventHandler} from 'react'
import {TextProps} from '@yosmanyga/primitive-ui-spec'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {InteractFn, SpacialFn, styled, TextFn, VisualFn} from '@yosmanyga/web-style'

const Text = forwardRef<HTMLParagraphElement, TextProps<
  MouseEventHandler<HTMLButtonElement>
> & UnnormalizedStyleProps>(({
  onClick,
  tag,
  className, testId,
  children
}, ref) => {
  const Tag: ElementType = tag || 'p'

  // Is a Fragment?
  if (Tag === Fragment) {
    return children
  }

  return <Tag
    ref={ref}
    onClick={onClick}
    className={className}
    data-testid={testId}
  >
    {children}
  </Tag>
})

const StyledText = styled(Text)`
  ${({align}) => SpacialFn.compileAlign(align)} // Remove default html margin
  margin-top: 0;
  margin-bottom: 0;

  ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}
  ${({padding}) => SpacialFn.compilePadding(SpacialFn.normalizePadding(padding))}
  ${({width}) => SpacialFn.compileWidth(SpacialFn.normalizeWidth(width))}
  ${({border}) => VisualFn.compileBorder(VisualFn.normalizeBorder(border))}
  ${({background}) => VisualFn.compileBackground(VisualFn.normalizeBackground(background))}
  ${({color}) => VisualFn.compileColor(color)}
  &::placeholder {
    ${({color}) => VisualFn.compileColor(color)}
  }

  ${({cursor}) => InteractFn.compileCursor(cursor)}

  ${({decoration}) => TextFn.compileDecoration(decoration)}
  ${({font}) => TextFn.compileFont(font)}
  ${({line}) => TextFn.compileLine(line)}
  ${({whitespace}) => TextFn.compileWhitespace(TextFn.normalizeWhitespace(whitespace))}
`

export default StyledText
